import { type BoxProps, Flex, type MantineColor, rem } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

export interface IconProps extends BoxProps {
	icon: JSX.Element;
	size?: number;
	color?: MantineColor;
}

export const Icon = ({ icon, size = 24, color, ...props }: IconProps) => {
	return (
		<Flex component='span' align='baseline' c={color} style={{ width: rem(size), height: rem(size) }} {...props}>
			{React.cloneElement(icon, {
				style: { width: rem(size), height: rem(size) },
			})}
		</Flex>
	);
};
